import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-49f0b9c2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "OkWhatsapp__controls" }
const _hoisted_2 = {
  key: 0,
  class: "controls__files"
}
const _hoisted_3 = { class: "file__name" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "controls__content" }
const _hoisted_6 = ["disabled"]
const _hoisted_7 = { class: "controls__buttons" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  d: "M16.9986 10.0318C16.9998 9.96982 16.9844 9.90889 16.9546 9.85728C16.9248 9.80567 16.882 9.76587 16.832 9.74324L4.36491 4.01956C4.31774 3.99965 4.26679 3.99483 4.21744 4.0056C4.16809 4.01638 4.12219 4.04235 4.08458 4.08078C4.0477 4.12072 4.02137 4.17189 4.00864 4.22837C3.9959 4.28486 3.99727 4.34435 4.0126 4.39997L5.20211 8.85998C5.20693 8.88923 5.21926 8.91613 5.2375 8.93719C5.25574 8.95824 5.27905 8.97248 5.30439 8.97804L12.3581 9.83506C12.39 9.84032 12.4192 9.8587 12.4403 9.88681C12.4614 9.91492 12.4731 9.95089 12.4731 9.9881C12.4731 10.0253 12.4614 10.0613 12.4403 10.0894C12.4192 10.1175 12.39 10.1359 12.3581 10.1411L5.31575 11.0113C5.29041 11.0168 5.26711 11.0311 5.24887 11.0521C5.23062 11.0732 5.21829 11.1001 5.21347 11.1293L4.02397 15.5893C4.00745 15.6442 4.00466 15.7033 4.01592 15.7599C4.02717 15.8166 4.05201 15.8684 4.08759 15.9094C4.12317 15.9505 4.16806 15.9792 4.2171 15.9922C4.26615 16.0052 4.31737 16.0019 4.36491 15.9829L16.8471 10.3379C16.8969 10.3115 16.9382 10.2678 16.9654 10.2129C16.9926 10.158 17.0042 10.0947 16.9986 10.0318Z",
  fill: "#0263E0"
}, null, -1))
const _hoisted_9 = [
  _hoisted_8
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_state_message = _resolveComponent("state-message")!
  const _component_chat_message = _resolveComponent("chat-message")!
  const _component_files_input = _resolveComponent("files-input")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["OkWhatsapp", { 'OkWhatsapp--disabled': _ctx.isComponentDisabled }])
  }, [
    _createVNode(_component_state_message, {
      loading: _ctx.chatStateMessage.is_loading,
      "is-error": _ctx.chatStateMessage.is_failed,
      message: _ctx.chatStateMessage.message
    }, null, 8, ["loading", "is-error", "message"]),
    _createElementVNode("div", {
      id: "chat-window",
      class: _normalizeClass(["OkWhatsapp__window", { 'window--opacity': Boolean(_ctx.chatStateMessage.message) }])
    }, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.chatWindow.messages, (message, i) => {
        return (_openBlock(), _createBlock(_component_chat_message, {
          key: `message-${i}`,
          message: message
        }, null, 8, ["message"]))
      }), 128))
    ], 2),
    _createElementVNode("div", _hoisted_1, [
      (_ctx.chatControl.files.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createElementVNode("p", null, "Прикреплено (" + _toDisplayString(_ctx.chatControl.files.length) + "):", 1),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.chatControl.files, (file, i) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "files__file",
                key: file.name
              }, [
                _createElementVNode("div", _hoisted_3, _toDisplayString(file.name), 1),
                (!_ctx.isComponentDisabled)
                  ? (_openBlock(), _createElementBlock("i", {
                      key: 0,
                      class: "fas fa-times cursor-pointer",
                      onClick: ($event: any) => (_ctx.removeFile(i))
                    }, null, 8, _hoisted_4))
                  : _createCommentVNode("", true)
              ]))
            }), 128))
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_5, [
        _withDirectives(_createElementVNode("textarea", {
          class: "controls__input",
          placeholder: "Написать сообщение...",
          disabled: _ctx.isComponentDisabled,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.chatControl.value) = $event))
        }, null, 8, _hoisted_6), [
          [_vModelText, _ctx.chatControl.value]
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createVNode(_component_files_input, {
            value: _ctx.chatControl.files,
            "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.chatControl.files) = $event)),
            disabled: _ctx.isComponentDisabled
          }, null, 8, ["value", "disabled"]),
          (_openBlock(), _createElementBlock("svg", {
            width: "20",
            height: "20",
            viewBox: "0 0 20 20",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onSubmitMessage && _ctx.onSubmitMessage(...args)))
          }, _hoisted_9))
        ])
      ])
    ])
  ], 2))
}